export const accounts = {
	title: "Cuentas Guardadas",
	saveNewAccountButton: "Guardar nueva cuenta",
	filterInputPlaceholder: "Filtrar cuentas guardadas",
	table: {
		holder: "Titular de la cuenta",
		holderTooltip: "Razón social o nombre del propietario de la cuenta",
		name: "Identificación",
		pixKey: "Clave Pix",
		agency: "Sucursal",
		account: "Cuenta",
		accountType: "Tipo de cuenta",
		deletePopconfirm: '¿Está seguro que desea eliminar la cuenta "{{name}}"?',
		withdraw: "Retirar",
		anticipate: "Anticipar",
	},
	drawerTitle: "Guardar cuenta",
	addNewAccount: "Agregar nueva cuenta",
	form: {
		holder: "Razón Social/Nombre del propietario",
		holderPlaceholder: "Ingrese aquí la razón social/nombre del propietario",
		name: "Identificación de la cuenta",
		nameTooltip: "Título por el cual identificará la cuenta",
		namePlaceholder: "Ingrese aquí el nombre de la cuenta",
		bank: "Banco",
		bankPlaceholder: "Seleccione aquí el banco o escriba para buscar",
		documentType: "Tipo de documento",
		cnpj: "RFC",
		cpf: "RFC",
		none: "Ninguno",
		documentNumber: "RFC",
		documentNumberPlaceholder: "Ingrese aquí el documento del titular de la cuenta",
		agency: "Sucursal",
		agencyPlaceholder: "Ingrese aquí la sucursal (sin dígito)",
		agencyWithDigitPlaceholder: "Ingrese aquí la sucursal (con dígito)",
		agencyDigitPlaceholder: "Ingrese aquí el dígito de la sucursal",
		agencyDigit: "Dígito",
		account: "Cuenta",
		accountDigit: "Dígito",
		accountPlaceholder: "Ingrese aquí la cuenta (sin dígito)",
		accountDigitPlaceholder: "Ingrese aquí el dígito de la cuenta",
		accountType: "Tipo de cuenta",
		noneAccount: "Ninguna",
		contaCorrente: "Corriente",
		contaPoupanca: "Ahorro",
		contaSalario: "Nómina",
		pixKey: "Clave PIX",
		pixKeyPlaceholder: "Ingrese aquí la clave PIX de la cuenta",
		selectAccountPlaceholder: "Escriba o seleccione la cuenta",
		accountDataType: "Datos para registrar",
		bankAccount: "Datos bancarios",
		pix: "PIX",
		saveAccountFuture: "Guardar cuenta para transacciones futuras",
	},
	formErrors: {
		holder: "Ingrese el nombre del titular de la cuenta",
		name: "Ingrese el nombre para identificar la cuenta",
		bank: "Seleccione el banco al que pertenece la cuenta",
		documentNumber: "Ingrese el documento del titular de la cuenta (RFC)",
		documentNumberInvalid: "Documento inválido",
		agency: "Ingrese el número de la sucursal",
		agencyInvalid: "Sucursal inválida",
		account: "Ingrese el número de la cuenta",
		accountDigit: "Ingrese el dígito de la cuenta",
		accountType: "Seleccione el tipo de la cuenta",
		pixKey: "Ingrese la clave PIX",
		pixKeyInvalid: "Clave PIX inválida",
		receiverDataWrapper: "Complete los datos bancarios o clave PIX",
	},
	accountTypes: {
		checking: "Cuenta Corriente",
		savings: "Cuenta de Ahorro",
		salary: "Cuenta de Nómina",
	},
};
